/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-default */
import React from 'react'
import { default as lodash } from 'lodash'

import { randomKey } from 'utils/functions'
import styles from './styles'

const infos = {
  options: {
    fields: {
          processo: 'Número do Processo',
          ramoDireito: 'Ramo',
          dataDistribuicao: 'Data de Distribuição',
          passivos: {
            name: 'Passivos',
            fields: {
              cpf: 'CPF',
              cnpj: 'CNPJ',
              nome: 'Nome',
              tipo: 'Tipo',
            },
          },
          ativos: {
            name: 'Ativos',
            fields: {
              cpf: 'CPF',
              cnpj: 'CNPJ',
              nome: 'Nome',
              tipo: 'Tipo',
            },
          },
          outrasPartes: {
            name: 'Outras Partes',
            fields: {
              cpf: 'CPF',
              cnpj: 'CNPJ',
              nome: 'Nome',
              tipo: 'Tipo',
            },
          },
        },
      },
    }

const NeowayProcessRow = ({ title, processes }) => {
  const classes = styles()
 

  const renderProcesses = () => {
    const renderFields = (item, optFields, componentName) => {
      return Object.entries(optFields).map(([key, val]) => {
        if (!item[key]) {
          return null
        }
        return <div key={randomKey(componentName)}>{renderField(item[key], val)}</div>
    })
    }

    const renderField = (content, fieldVal) => {
      if (lodash.isString(content) || lodash.isBoolean(content)) {
        return (
          <React.Fragment>
            <strong>{fieldVal}</strong>
            {': '}
            {lodash.isString(content)
              ? content
              : content === true
              ? 'Sim'
              : 'Não'}
          </React.Fragment>
        )
      }

      if (lodash.isArray(content)) {
        return (
          <React.Fragment>
            <strong>{fieldVal.name}</strong>
            {lodash.map(content, (itemChild, i) => (
              <ul key={randomKey(i.toString())}>
                <li>
                  {lodash.isString(itemChild)
                    ? itemChild
                    : renderFields(itemChild, fieldVal.fields, `${fieldVal.name} ${i} ${title}`)}
                </li>
              </ul>
            ))}
          </React.Fragment>
        )
      }

      return null
    }

    return (
      <div style={{ marginLeft: 10,   paddingBottom: 10,
        paddingTop: 10,
        borderBottom: '1px solid #ddd' }}>
          {lodash.map(processes, (process) => (  
             lodash.map(infos.options.fields, (fieldVal, fieldKey) => {
              const info = lodash.get(process, fieldKey)
              
              return (
                info && <div
                  key={randomKey()}
              >
                {renderField(info, fieldVal)}
              </div>
              )
            }) 
          ))}
      </div>
    )
  }

  return (
    <div className={classes.expansibleContent}>
      <span className={classes.title}>{title}</span>

      <div className={classes.processHeadInfo}>
        <span>
          <b>Número de Processos: </b>
          {processes.length}
        </span>
      </div>

      <span>Lista de processos:</span>
      {renderProcesses()}
    </div>
  )
}

export default NeowayProcessRow
